import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <polygon points="23.4,0 12.5,11 1.6,0 0,1.5 0,1.5 11,12.5 0.1,23.4 1.5,25 1.6,25 12.5,14 23.4,25 25,23.4 25,23.4 14,12.5 25,1.5 23.5,0 " />
    </g>
  </svg>
);
